import { ChevronsUpDown } from "lucide-react";

import { departmentMap, getHumanReadableDepartment } from "@/api/types/helpers/functions";
import { useUserControllerUpdateSelf } from "@/api/types/main";
import { Department, UpdateUserRequest } from "@/api/types/main/schemas";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@/components/ui/sidebar";
import { useUserStore } from "@/store/user";
import { toast } from "sonner";

function DepartmentSwitcher() {
  const { isMobile } = useSidebar();

  const user = useUserStore((store) => store.user);
  const departments = Object.keys(departmentMap) as Department[];

  const { mutate: updateDepartment } = useUserControllerUpdateSelf({
    mutation: {
      onSuccess: (data) => {
        useUserStore.getState().setUser(data);
        toast.success(`Департамент успешно обновлен`);
      },
      onError: (error) => {
        toast.error(`Ошибка при обновлении департамента: ${error.message}`);
      },
    },
  });

  const setActiveDepartment = (department: Department) => {
    if (!user?.id) return;
    const data: UpdateUserRequest = {
      name: user.name,
      surname: user.surname,
      role: user.role,
      gender: user.gender,
      isActivate: user.isActivate,
      department,
    };
    updateDepartment({ data });
  };

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              size="lg"
              className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
            >
              <div className="bg-sidebar-primary text-sidebar-primary-foreground flex aspect-square size-8 items-center justify-center rounded-lg font-bold">
                F
              </div>
              <div className="grid flex-1 text-left text-sm leading-tight">
                <span className="truncate font-medium">
                  {getHumanReadableDepartment(user.department)}
                </span>
              </div>
              <ChevronsUpDown className="ml-auto" />
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className="w-(--radix-dropdown-menu-trigger-width) min-w-56 rounded-lg"
            align="start"
            side={isMobile ? "bottom" : "right"}
            sideOffset={4}
          >
            <DropdownMenuLabel className="text-muted-foreground text-xs">
              Департаменты
            </DropdownMenuLabel>
            {departments.map((department) => (
              <DropdownMenuItem key={department} onClick={() => setActiveDepartment(department)}>
                {getHumanReadableDepartment(department)}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}

export default DepartmentSwitcher;
